import React from "react";

const Filler = () => {
	return (
		<>
			<div className="h-14 sm:h-20"></div>
		</>
	);
};

export default Filler;
